module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/54AwGaB6J2OgMggS2ksUM4-985c5c2eb653656e95821293ecdad1cd.jpg";